<template lang="en">
<div class="doctor-profile">
    <Navigation></Navigation>
    <div id="breadcrumb">
        <div class="container">
            <ul>
                <li>
                    <router-link tag="a" to="/">Inicio</router-link>
                </li>
                <li>Preguntas frecuentes</li>
            </ul>
        </div>
    </div>
    <!-- /breadcrumb -->

    <div class="container margin_60">
        <div class="row">
            <aside class="col-lg-3" id="sidebar">
                <div class="box_style_cat" id="faq_box">
                    <ul id="cat_nav">
                        <li><a href="#payment" class="active">Pagos</a></li>
                        <li><a href="#tips">Cancelaciones</a></li>
                    </ul>
                </div>
                <!--/sticky -->
            </aside>
            <!--/aside -->

            <div class="col-lg-9" id="faq">

                <div role="tablist">
                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <div v-b-toggle.accordion-1>
								<span class="when-opened "><i class="pe-7s-angle-up"></i></span> <span class="when-closed"> <i class="pe-7s-angle-down"></i></span> 
								¿Pregunta número 1?
							</div>
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Text de la respuesta número 2
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <div v-b-toggle.accordion-2>
								<span class="when-opened "><i class="pe-7s-angle-up"></i></span> <span class="when-closed"> <i class="pe-7s-angle-down"></i></span> 
								¿Pregunta número 2?
							</div>
                        </b-card-header>
                        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
                                    Text de la respuesta número 2
                                </b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <div v-b-toggle.accordion-3>
								<span class="when-opened "><i class="pe-7s-angle-up"></i></span> <span class="when-closed"> <i class="pe-7s-angle-down"></i></span> 
								¿Pregunta número 3?
							</div>
                        </b-card-header>
                        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>
									Text de la respuesta número 3
								</b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>

            </div>
            <!-- /col -->
        </div>
        <!-- /row -->
    </div>

    <Footer></Footer>

</div>
</template>

<script>
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

export default {
    name: 'Faqs',
    metaInfo: {
		title: 'Preguntas frecuentes',
	},
    components: {
        Navigation,
        Footer,
    },
    data() {
        return {

        }
    },

}
</script>

<style scoped>
.p-1>div{
	padding: 8px;
	cursor: pointer;
}
.p-1>div i{
	float: right;
	font-size: 28px;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}


</style>
